import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Button } from '@estee/elc-buttons';
import { CTA_TYPE } from '../../constants/NotifyMe';

export interface IProductNotifyMeButton {
    label: string;
    onNotifyMeClick?(): void;
    ctaType?: string;
}

const StyledButton = styled(Button)`
    width: 100%;
    margin-right: 15px;
    height: 40px;
    border: none;
    padding: 0 15px;
    cursor: pointer;

    [dir='rtl'] & {
        margin-left: 15px;
        margin-right: 0;
    }
`;

const StyledLink = styled.a`
    cursor: pointer;
`;

export const ProductNotifyMeButton = observer((props: IProductNotifyMeButton) => {
    const handleClick = (event: React.MouseEvent) => {
        if (props.onNotifyMeClick) {
            event.preventDefault();
            props.onNotifyMeClick();
        }
    };

    const hasTypeLink = props.ctaType === CTA_TYPE.LINK;
    const productNotifyMeButtonClassNames = hasTypeLink
        ? 'elc-product-notify-me-link'
        : 'elc-product-notify-me-button';

    if (hasTypeLink) {
        return (
            <StyledLink className={productNotifyMeButtonClassNames} onClick={handleClick}>
                {props.label}
            </StyledLink>
        );
    }

    return (
        <StyledButton className={productNotifyMeButtonClassNames} onClick={handleClick}>
            {props.label}
        </StyledButton>
    );
});
